<template>
    <div>
        <top-nav :routelist="routeList"></top-nav>
        <router-view></router-view>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
    watch: {
        '$route': 'setFirstRoute'
    },
    computed: {
        ...mapGetters(['hasPermission']),
        routeList() {
            return [
                {
                    name: '人员管理',
                    route: 'sys_employee',
                    right: this.hasPermission('sys_employee'),
                },
                {
                    name: '移动端',
                    route: 'sys_app',
                    right: this.hasPermission('sys_app'),
                }
            ]
        }
    },
    methods: {
        setFirstRoute() {
            if (this.$route.name === 'system') {
                for (let item of this.routeList) {
                    if (item.right) {
                        this.$router.push({name: item.route})
                        return
                    }
                }
            }
        }
    },
    created() {
        this.setFirstRoute()
    }
}
</script>
